import { CustomerData, CustomerLists, GponXProfiles, Oid, Ont, OntsBySerialNum } from "@ip6m/types";
import { Injectable, NotFoundException } from "@nestjs/common";
import { firstValueFrom } from "rxjs";
import { CustomerService } from "../../customer-api/services/customer.service";
import { OidDefinition } from "../interfaces/oid";
import { HuaweiOidDB } from "./huawei_oid.service";
import { OidDB } from "./oid.service";
import { SnmpService } from "./snmp.service";

const snmp = require("net-snmp");
@Injectable()
export class GponService {
    
    constructor(
        private oidDB: OidDB, 
        private huawei_oidDB: HuaweiOidDB,
        private snmpService: SnmpService,
        private customerService: CustomerService
    ) {}

    async getXProfiles(oltid: any, profileType: string = 'line') { // 'line' or 'service'

        let oidDef: OidDefinition;

        switch(profileType) {
            case 'line': oidDef = this.huawei_oidDB.GponLineProfiles(); break;
            case 'service': oidDef = this.huawei_oidDB.GponServiceProfiles(); break;
            default: oidDef = this.huawei_oidDB.GponLineProfiles();
        }
        
        const SnmpResult = await this.snmpService.table(oltid, oidDef.base);
        let result: String[] = [];

        Object.keys(SnmpResult).forEach(key => {
            let name = '';
            key.split('.').forEach(charString => {
                name = name + String.fromCharCode(parseInt(charString));
            });
            result.push(name);
        });

        return result;
    }

    async activateOnt(oltid: any, ifIndex: any, sn: any, profiles: GponXProfiles) {
        const oidDef = this.huawei_oidDB.GponDeviceOnt();
        const oidStatus = oidDef.base + "." + oidDef.children["hwGponDeviceOntEntryStatus"];
        const oidSn = oidDef.base + "." + oidDef.children["hwGponDeviceOntSn"];
        const oidLineProf = oidDef.base + "." + oidDef.children["hwGponDeviceOntLineProfName"];
        const oidServiceProf = oidDef.base + "." + oidDef.children["hwGponDeviceOntServiceProfName"];
        console.log(sn, profiles.lp, profiles.sp);
        const oids = [{
           oid: oidSn + "." + ifIndex + ".4294967295",
           value: Buffer.from(sn, 'hex'),
           type: snmp.ObjectType.OctetString
        },{
           oid: oidStatus + "." + ifIndex + ".4294967295",
           value: snmp.RowStatus.active,
           type: snmp.ObjectType.RowStatus
        }];
        if(profiles.lp) {
            oids.push({
                oid: oidLineProf + "." + ifIndex + ".4294967295",
                value: Buffer.from(profiles.lp),
                type: snmp.ObjectType.OctetString
            })
        }
        if(profiles.sp) {
            oids.push({
                    oid: oidServiceProf + "." + ifIndex + ".4294967295",
                    value: Buffer.from(profiles.sp),
                    type: snmp.ObjectType.OctetString
            })
        }   
        
        const snmpResp = await this.snmpService.set(oltid, oids).catch((error) => {
            if(error.name == snmp.ResponseInvalidError.name) {
                return {
                    sn: sn,
                    activated: true
                };
            } else {
                throw new NotFoundException(error.toString());
            }

        });
        
        return snmpResp;
    }

    async deActivateOnt(oltid: number, ifIndex: number, ontId: number) {
        const oidDef = this.huawei_oidDB.GponDeviceOnt();
        const oid = oidDef.base + "." + oidDef.children["hwGponDeviceOntEntryStatus"];
        const oids = [{
            oid: oid + "." + ifIndex + "." + ontId,
            value: snmp.RowStatus.destroy,
            type: snmp.ObjectType.Integer
        }];
        const snmpResp = await this.snmpService.set(oltid, oids).catch((error) => {
            throw new NotFoundException(error.toString());       
        });
        // TODO: get ont serial num from somewhere, and:
        // this.ddmDeviceService.deleteOnt(sn);

        return {
            oltid: oltid,
            ifIndex: ifIndex,
            ontId: ontId,
            deactivated: true
        };
    }
  
    async getPorts(oltid: any) {
            const oids = this.huawei_oidDB.GponPorts();
            const numericOids = this.oidDB.getChildrenOids(oids);
            const names = this.oidDB.getChildrenNames(oids);
                
            let result: Oid[] = [];
            for(let i=0; i<numericOids.length; i++) {
                const snmpResult:Oid[] = await this.snmpService.subtree(oltid, numericOids[i]);
                snmpResult.forEach((value) => {
                    value.name = names[i];
                    result.push(value);
                });        
            }
    
            return result;
    }

    async getPort(oltid: any, ifIndex: number) {
        const oids = this.huawei_oidDB.GponPorts();
        const numericOids = this.oidDB.getChildrenOids(oids);
        const names = this.oidDB.getChildrenNames(oids);
    
        let genOids: string[] = [];
        for(let i=0; i<numericOids.length; i++) {
            genOids.push(numericOids[i] + '.' + ifIndex)
        }
        const result:Oid[] = await this.snmpService.get(oltid, genOids);
        for(let i=0; i<result.length; i++) {
            result[i].name = names[i];
        }
    
        return result;
    }

    async getAutofoundOnts(oltid: any, ifIndex: number = 0) {
        const oids = this.huawei_oidDB.GponOntAutofound();
        const numericOids = this.oidDB.getChildrenOids(oids);
        const names = this.oidDB.getChildrenNames(oids);

        let result: Ont[] = [];
        for(let i=0; i<numericOids.length; i++) {
            let oid = numericOids[i];
            if(ifIndex) {
                oid = oid + '.' + ifIndex;
            }
            const snmpWalk:Oid[] = await this.snmpService.subtree(oltid, oid);
            
            for(let j=0; j<snmpWalk.length; j++)  {
                if (names[i] == 'hwGponDeviceOntRegisterSn') {  // Add new ONT
                    const oidArray = snmpWalk[j].oid.split('.');
                    const ontId = parseInt(oidArray.pop(), 10);
                    const oidIfIndex = parseInt(oidArray.pop(), 10);
                    
                    result.push({
                        oltId: oltid,
                        ifIndex: oidIfIndex,
                        ontId: ontId,
                        sn: snmpWalk[j].value.toString('hex')
                    });
                } else {                                        // Append Oid to existing ONT
                    result[j][names[i]] = snmpWalk[j].value;
                }
            };
        };

        return result;
    }

    async getOnts(oltid: any, ifIndex: number = 0): Promise<OntsBySerialNum> {
        const oidsGponDevice = this.huawei_oidDB.GponDeviceOnt();
        const oidsGponInfo = this.huawei_oidDB.GponOntInfoTable();
        const oidsGponInfoNames = this.huawei_oidDB.getChildrenNames(oidsGponInfo);
        
        let result: OntsBySerialNum = {};

        const selectedGponDeviceOidNames: string[] = [
            'hwGponDeviceOntSn',
            'hwGponDeviceOntLineProfName',
            'hwGponDeviceOntServiceProfName',
            'hwGponDeviceOntDespt'
        ];
        let selectedOids: string[] = [];
        selectedGponDeviceOidNames.forEach(name => {
            selectedOids.push(oidsGponDevice.base + '.' + oidsGponDevice.children[name]);
        });
        oidsGponInfoNames.forEach(name => {
            selectedOids.push(oidsGponInfo.base + '.' + oidsGponInfo.children[name])
        });
        

        if (ifIndex) {  // filter by ifIndex
            selectedOids = selectedOids.map( oid => oid + '.' + ifIndex );
        }
   
        let snmpResponse = [];
        for(let i=0; i<selectedOids.length; i++) {
            try {
                snmpResponse[i] = await this.snmpService.subtree(oltid, selectedOids[i]);
            } catch {
                throw new Error('OLT snmp query was unsuccesfull at GponService.getOnts('+oltid+')');
            }
        }

        for(let i = 0; i<snmpResponse[0].length; i++) {  // Serial numbers oid
            const snmpOnt = snmpResponse[0][i];
            const oidSplit = snmpOnt.oid.split('.');
            const ontId = parseInt(oidSplit.pop(), 10);
            const ifIndex = parseInt(oidSplit.pop(), 10);
            const sn = snmpOnt.value.toString('hex').toUpperCase();
            
            let cd: CustomerLists = {};
            let customer: CustomerData;
            try {
                cd = await firstValueFrom(this.customerService.getCustomers(sn));
            }
            catch(err) {
                customer = null;
            }
            
            Object.values(cd).forEach(customerList => {
               if( Object.keys(customerList).length) {
                   customer = customerList[Object.keys(customerList)[0]];
               }
            })
    
            result[sn]= {
                oltId: oltid,
                ifIndex: ifIndex,
                ontId: ontId,
                sn: sn,
                customer: customer
            };
            const deviceOidsNum = selectedGponDeviceOidNames.length;
            for(let j=1; j<deviceOidsNum; j++) {  
                result[sn][selectedGponDeviceOidNames[j]] = snmpResponse[j][i].value;
            };
            for(let j=0; j<oidsGponInfoNames.length; j++) {
                result[sn][oidsGponInfoNames[j]] = snmpResponse[j+deviceOidsNum][i].value;
            }
        };    

        return result;
    }
}